import { useEffect, useState } from "react";

// Koniec promocji na kurs „Gry i zabawy językowe": północ z 10.11 na 11.11.2026 (czas polski, CET = UTC+1)
const DEADLINE = new Date("2026-11-11T00:00:00+01:00").getTime();

export function useCountdown(targetMs) {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    const diff = Math.max(0, targetMs - now);
    return {
        expired: diff <= 0,
        days: Math.floor(diff / 86400000),
        hours: Math.floor(diff / 3600000) % 24,
        minutes: Math.floor(diff / 60000) % 60,
        seconds: Math.floor(diff / 1000) % 60,
    };
}

export function usePresaleCountdown() {
    return useCountdown(DEADLINE);
}

const UNITS = [
    { key: "days", label: "dni" },
    { key: "hours", label: "godz" },
    { key: "minutes", label: "min" },
    { key: "seconds", label: "sek" },
];

export function CountdownDigits({ time, dark = false, testIdPrefix }) {
    return (
        <div className="flex items-center gap-1.5 sm:gap-2" role="timer" data-testid={`${testIdPrefix}-digits`}>
            {UNITS.map((u) => (
                <div
                    key={u.key}
                    className={`min-w-[3.1rem] rounded-xl px-2 py-1.5 text-center ${
                        dark ? "bg-white/15 backdrop-blur-sm" : "bg-white shadow-sm"
                    }`}
                >
                    <span
                        className={`block font-mono text-lg sm:text-xl font-extrabold tabular-nums leading-none ${
                            dark ? "text-white" : "text-brand-deep"
                        }`}
                        data-testid={`${testIdPrefix}-${u.key}`}
                    >
                        {String(time[u.key]).padStart(2, "0")}
                    </span>
                    <span
                        className={`mt-1 block text-[9px] font-bold uppercase tracking-[0.14em] ${
                            dark ? "text-white/75" : "text-brand-gray"
                        }`}
                    >
                        {u.label}
                    </span>
                </div>
            ))}
        </div>
    );
}
